<template lang="pug">
button.w-btn(
  :class='classes'
  v-on='listeners'
)
  slot
</template>

<script lang="js">
import { Clickable } from '@/mixins'

export const mixin = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input( value ) {
      this.$emit( 'input', value )
    }
  }
}

export default {
  name: 'ButtonWidget',
  mixins: [ Clickable ],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.w-btn {
  --fs-input: var(--s-xl);
  background: transparent;
  border: var(--bw-btn, 0) var(--bs-btn, none) var(--bc-btn, transparent);
  border-radius: var(--br-btn, 2px);
  font-size: var(--fs-btn, var(--fs-input, var(--s-lg)));
  transition: all 250ms;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  &:hover {
    background: rgba(255,255,255,0.2);
  }
  &:active, &.active {
    transition: 0s;
    background: white;
    box-shadow: 0 0 8px white;
  }
  &.disabled {
    opacity: 0.5;
    &:active, &.active {
      transition: 0s;
      background: red;
      box-shadow: 0 0 8px red;
    }
  }
  > span {
    line-height: 1.4em;
  }
}
</style>
